import React from "react";
import { ManagerDashboard } from "./ManagerDashboard";

// Employee-facing page: company-wide activities list (activities tab only).
export const CompanyActivities: React.FC = () => {
  return <ManagerDashboard variant="company-activities" />;
};

